import { z } from "zod/v4";
import { winningSideSchema } from "./shared";

export const setScoreSchema = z.object({
	id: z.string().uuid(),
	match_id: z.string().uuid(),
	set_number: z.number().int(),
	team1_score: z.number().int(),
	team2_score: z.number().int(),
	winning_side: winningSideSchema.nullable(),
});

export const createSetScoreSchema = setScoreSchema.omit({ id: true });

export const updateSetScoreSchema = createSetScoreSchema.partial();
